module.exports = __webpack_public_path__ + "img/global-2016-forum.6a9d109e.jpg";